__turbopack_context__.v({
  "desktopSearch": "search-module__UNItuG__desktopSearch",
  "mobileSearch": "search-module__UNItuG__mobileSearch",
});
